import { UserCenterService, bUserService } from '@/utils/axios'

const regApi = {
  sendCode: '/api/services/app/Account/SendAliSmsAsync/v2', // 发送验证码,
  createOrUpdateCompanyInfo: '/api/services/app/Account/Register', // 注册公司信息-提交表单
  createCompanyService: '/api/services/app/CompanyServiceProvider/CreateOrUpdate',
  validCompany: '/api/services/app/AbpCompany/ValidCompany', // 验证公司信用代码
  ValidCompanyName: '/api/services/app/AbpCompany/ValidCompanyName', // 验证公司名
  validUser: '/api/services/app/Account/ValidNameOrEmail', // 验证账号信息
  editCompany: '/api/services/app/AbpCompany/CreateOrUpdate', // 完善公司信息
  createFile: '/api/services/app/HonorFile/CreateOrUpdate', // 提交文件
  userCenterRegisterWihtNoCode: '/api/services/app/Account/RegisterWihtNoCode', // 注册用户（不需要验证码）
  platfromCenterRegister: '/api/TokenAuth/RegisterAnyUserAsync', // 平台用户入库
  platfromCenterGetTenantPage: 'api/public/api/services/app/Tenant/getPaged' // 平台中心获取平台数据
}

export function platfromCenterGetTenantPage (params) {
  return bUserService({
    url: regApi.platfromCenterGetTenantPage,
    method: 'get',
    params
  })
}

export function platfromCenterRegister (data) {
  return bUserService({
    url: regApi.platfromCenterRegister,
    method: 'post',
    data
  })
}

export function getRegCode (parameter) {
  return UserCenterService({
    url: regApi.sendCode,
    method: 'post',
    data: parameter
  })
}

export function createCompanyInfo (parameter, tenantId) {
  return UserCenterService({
    url: regApi.createOrUpdateCompanyInfo,
    method: 'post',
    data: parameter,
    transformRequest: [(data, headers) => {
      headers['Abp.TenantId'] = tenantId
      return JSON.stringify(data)
    }],
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

export function createCompanyService(params) {
  return UserCenterService({
    url: regApi.createCompanyService,
    method: 'post',
    data: params
  })
}

export function userCenterRegisterWihtNoCode (parameter, tenantId) {
  return UserCenterService({
    url: regApi.userCenterRegisterWihtNoCode,
    method: 'post',
    data: parameter,
    transformRequest: [(data, headers) => {
      headers['Abp.TenantId'] = tenantId
      return JSON.stringify(data)
    }],
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

export function validCompany (companyNo) {
  return UserCenterService({
    url: regApi.validCompany,
    method: 'post',
    params: {
      companyNo
    }
  })
}

export function validCompanyName (companyName) {
  return UserCenterService({
    url: regApi.ValidCompanyName,
    method: 'post',
    params: {
      companyName
    }
  })
}

export function validUser (usernameOrEmailAddress) {
  return UserCenterService({
    url: regApi.validUser,
    method: 'post',
    params: {
      usernameOrEmailAddress
    }
  })
}

export function editCompany (abpCompany) {
  return UserCenterService({
    url: regApi.editCompany,
    method: 'post',
    data: {
      abpCompany
    }
  })
}

export function createFile (honorFile) {
  return UserCenterService({
    url: regApi.createFile,
    method: 'post',
    data: {
      honorFile
    }
  })
}

const resetPwdApi = {
  getTenant: '/api/services/app/Tenant/GetAll', // 获取用户角色
  checkUsernameOrPhone: '/api/services/app/Account/CheckChangePassCaptcha', // 找回密码: 验证账号、绑定的手机号码
  changePwd: '/api/services/app/Account/ChangePassword', // 找回密码: 修改密码
  GetCaptchaAccountByPhone: '/api/services/app/Account/GetCaptchaAccountByPhone' // 根据手机验证码获取账号列表
}

export function getTenantData () {
  return UserCenterService({
    url: resetPwdApi.getTenant,
    method: 'get'
  })
}

export function checkUsernameOrPhone (parameter, tenantId) {
  return UserCenterService({
    url: resetPwdApi.checkUsernameOrPhone,
    method: 'post',
    data: parameter,
    headers: {
      'Abp.TenantId': tenantId
    }
  })
}

export function changePwd (parameter, tenantId) {
  return UserCenterService({
    url: resetPwdApi.changePwd,
    method: 'post',
    data: parameter,
    headers: {
      'Abp.TenantId': tenantId
    }
  })
}

export function GetCaptchaAccountByPhone (params) {
  return UserCenterService({
    url: resetPwdApi.GetCaptchaAccountByPhone,
    method: 'get',
    params: params
  })
}
